/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Fleet_AddInputs */

const en_clients_fleet_add = /** @type {(inputs: Clients_Fleet_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add fleet type`)
};

const pt_br2_clients_fleet_add = /** @type {(inputs: Clients_Fleet_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar tipo de frota`)
};

/**
* | output |
* | --- |
* | "Add fleet type" |
*
* @param {Clients_Fleet_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_fleet_add = /** @type {((inputs?: Clients_Fleet_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Fleet_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_fleet_add(inputs)
	return pt_br2_clients_fleet_add(inputs)
});